"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ResourceSharePopover = ResourceSharePopover;
var _react = _interopRequireWildcard(require("react"));
var _SharePanelAnchor = require("@common/components/share/SharePanelAnchor");
var _ShareAccessUnavailable = require("@common/components/share/ShareAccessUnavailable");
var _resourceShareDialog = require("@common/components/share/resource-share-dialog/resource-share-dialog");
var _AnalyticsContext = require("../../context/AnalyticsContext");
var _useResourceSharePanel = require("../../hooks/use-resource-share-panel");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var SHARE_POPOVER_VIEWPORT_GUTTER_PX = 16;
var SHARE_BASE_PATH = {
  file: "/api/files/user",
  prompt: "/api/prompts/user",
  clause: "/api/user-clauses"
};
function ResourceSharePopover(_ref) {
  var resourceKind = _ref.resourceKind,
    resourceId = _ref.resourceId,
    resourceName = _ref.resourceName,
    anchorEl = _ref.anchorEl,
    access = _ref.access,
    onClose = _ref.onClose;
  var _useAnalytics = (0, _AnalyticsContext.useAnalytics)(),
    analytics = _useAnalytics.analytics;
  var panel = (0, _useResourceSharePanel.useResourceSharePanel)(SHARE_BASE_PATH[resourceKind], resourceId);
  var track = (0, _react.useCallback)(function (event, properties) {
    return analytics === null || analytics === void 0 ? void 0 : analytics.track(event, properties);
  }, [analytics]);
  var shareDialog = access ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_resourceShareDialog.ResourceShareDialog, _objectSpread(_objectSpread({}, panel), {}, {
    resourceId: resourceId,
    resourceName: resourceName,
    resourceKind: resourceKind,
    canManageShares: access.canManageShares,
    track: track,
    viewportGutterPx: SHARE_POPOVER_VIEWPORT_GUTTER_PX,
    onClose: onClose
  })) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_ShareAccessUnavailable.ShareAccessUnavailable, {});
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_SharePanelAnchor.SharePanelAnchor, {
    anchorEl: anchorEl,
    onClose: onClose,
    "data-sentry-element": "SharePanelAnchor",
    "data-sentry-component": "ResourceSharePopover",
    "data-sentry-source-file": "ResourceSharePopover.tsx",
    children: shareDialog
  });
}